import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { class: "px-10 mt-5 w-full mx-auto" }
const _hoisted_3 = { class: "grid grid-cols-4 gap-6" }
const _hoisted_4 = { class: "overflow-hidden relative" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "flex justify-center w-full absolute bottom-4 transition duration-500 ease-in-out opacity-0 group-hover:opacity-100" }
const _hoisted_8 = { class: "px-4 py-3 bg-white" }
const _hoisted_9 = { class: "text-gray-800 font-semibold text-lg hover:text-red-500 transition duration-300 ease-in-out" }
const _hoisted_10 = { class: "flex py-2" }
const _hoisted_11 = { class: "text-red-600 font-bold text-2xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddToCart = _resolveComponent("AddToCart")!
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.fetching)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "my-5 text-2xl text-red-700" }, "Latest Products", -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products.latestProductQuery, (card, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `product-card-${index}`,
                class: "shadow hover:shadow-lg transition duration-300 ease-in-out xl:mb-0 lg:mb-0 md:mb-0 mb-6 cursor-pointer group"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_router_link, {
                    to: {name: 'product.show', params: {slug: card.slug}},
                    class: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "w-full transition duration-700 ease-in-out group-hover:opacity-60",
                        src: card.main_image_url,
                        alt: card.name
                      }, null, 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_AddToCart, {
                            slug: card.slug
                          }, null, 8, ["slug"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: {name: 'product.show', params: {slug: card.slug}},
                    class: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", _hoisted_9, _toDisplayString(card.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, "$" + _toDisplayString(card.price), 1)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}